import type { GridElement } from '@omnia/ui/src/lib/cms'
import type { FC } from 'react'
import { BannerTextImageAction } from '@/common/components/bannerTextImageAction/BannerTextImageAction'
import type { BannerTextImageActionPropsApi } from '@/common/components/bannerTextImageAction/models'

export const GridBannerTextImageAction: FC<GridElement<BannerTextImageActionPropsApi>> = ({ value }) => {
    return <BannerTextImageAction {...value} />
}
